// import BarrageContainer from "./barrageContainer/index.js";
import Barrage from './barrage/index.js';
import UIComponent from '../common/UIComponent';
import PlayBtn from './playBtn/index.js';
import CurrentTime from './currentTime/index.js';
import DefinitionBtn from './definitionBtn/index.js';
import SubtitleBtn from './subtitleBtn/index.js';
import SpeedBtn from './speedBtn/index.js';
import TimeshiftProgress from './timeshiftProgress/index.js';
import LiveShiftTime from './liveShiftTime/index.js';
import Progress from './progress/index.js';
import FullscreenBtn from './fullscreenBtn/index.js';
import VolumeBtn from './volumeBtn/index.js';
import ConfigBtn from './configBtn/index.js';
import MiddlePlayBtn from './middlePlayBtn';
import { debounce } from '../common/Utils';
import './index.css';
import Bubble from './bubble';

export default class Component extends UIComponent {
  constructor(elementId, interfaces, markPoints, AiHightlights) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.timer = null;

    this.markPoints = markPoints;
    this.AiHightlights = AiHightlights;

    // 声明当前播放器容器
    // @type HtmlElement
    this.UIContainer = document.querySelector(elementId);

    this.init();

    // 声明 当前控制条容器
    this.UIControlBar = this.UIMain;

    this.UIControlBar.style.display = this.UIContainer.offsetWidth <= 400 ? 'none' : 'block';
    this.controllerUp.style.display = this.UIContainer.offsetWidth <= 400 ? 'none' : 'block';

    window.addEventListener(
      'resize',
      debounce(() => {
        this.controllerUp.style.display = this.UIContainer.offsetWidth <= 400 ? 'none' : 'block';
        this.UIControlBar.style.display = this.UIContainer.offsetWidth <= 400 ? 'none' : 'block';
      }, 100),
      false
    );

    // 控制条5s自动隐藏逻辑
    this.UIContainer.addEventListener(
      'mousemove',
      debounce(() => {
        this.showController();
        clearTimeout(this.hideControllerTimer);
        this.hideControllerTimer = setTimeout(() => {
          this.hideController();
        }, 5000);
      }, 50)
    );

    this.UIContainer.addEventListener('click', e => {
      e.preventDefault();
      if (this.isShowController()) {
        this.hideController();
        clearTimeout(this.hideControllerTimer);
      } else {
        this.showController();
        clearTimeout(this.hideControllerTimer);
        this.hideControllerTimer = setTimeout(() => {
          this.hideController();
        }, 5000);
      }
    });

    this.UIControlBar.addEventListener(
      'click',
      e => {
        e.stopPropagation();
        e.preventDefault();
      },
      false
    );

    this.controllerUp.addEventListener(
      'click',
      e => {
        e.stopPropagation();
        e.preventDefault();
      },
      false
    );
  }

  init() {
    this.UIMain = document.createElement('div');
    this.UIMain.setAttribute('class', 'vhallPlayer-container');

    var progress = document.createElement('div');
    progress.setAttribute('class', 'vhallPlayer-progress-box');
    var controller = document.createElement('div');
    controller.setAttribute('class', 'vhallPlayer-controller-box');

    var cleft = document.createElement('div');
    cleft.setAttribute('class', 'v-c-left');
    var cright = document.createElement('div');
    cright.setAttribute('class', 'v-c-right');
    controller.appendChild(cleft);
    controller.appendChild(cright);

    this.UIMain.appendChild(progress);
    this.UIMain.appendChild(controller);

    this.controllerUp = document.createElement('div');
    this.controllerUp.setAttribute('class', 'vhallPlayer-container-up');
    if (this.theme) {
      this.appendChild(this.elementId, this.controllerUp);
    }

    this.appendChild(this.elementId, this.UIMain);
    // new BarrageContainer(".vhallPlayer-container", this.interfaces);
    const isOpenTimeshift = this.interfaces.isLive ? this.interfaces.vhallplayer._config.isOpenTimeshift : null;
    const type = this.interfaces.vhallplayer._config.type;
    // flash不播时移，返回null，不显示时移UI
    const istx = this.interfaces.getCdnName() === 'tx';

    const vCLeft = this.UIMain.querySelector('.v-c-left');
    const vCRight = this.UIMain.querySelector('.v-c-right');
    const vProcess = this.UIMain.querySelector('.vhallPlayer-progress-box');

    new PlayBtn(vCLeft, this.interfaces, this.UIMain);

    if (this.interfaces.isLive) {
      // 开启了 时移直播 - 才初始化时移直播相关参数
      if (isOpenTimeshift && type === 'hls' && istx) {
        new LiveShiftTime(vCLeft, this.interfaces);
        new TimeshiftProgress(vProcess, this.interfaces);
        new Bubble(this.UIMain, this.interfaces);
      }
    } else {
      new SpeedBtn(vCRight, this.interfaces);
      new CurrentTime(vCLeft, this.interfaces);
      new Progress(vProcess, this.interfaces, this.elementId, this.markPoints, this.AiHightlights);
    }
    if (this.theme) {
      new Barrage(vCRight, this.interfaces);
      new VolumeBtn(vCRight, this.interfaces);
      new DefinitionBtn(vCRight, this.interfaces);
      // 移动端居中暂停按钮
      new MiddlePlayBtn(this.elementId, this.interfaces);
    } else {
      new DefinitionBtn(vCRight, this.interfaces);
      new Barrage(vCRight, this.interfaces);
      new SubtitleBtn(vCRight, this.interfaces, this.elementId, false);
      new VolumeBtn(vCRight, this.interfaces);
    }
    new ConfigBtn(vCRight, this.interfaces);
    new FullscreenBtn(vCRight, this.interfaces);
  }

  hideController() {
    this.controllerUp.style.display = 'none';
    this.UIControlBar.style.display = 'none';
  }
  showController() {
    this.controllerUp.style.display = 'block';
    this.UIControlBar.style.display = 'block';
  }
  isShowController() {
    return this.UIControlBar.style.display === 'block';
  }
}
